import { AxiosError } from "axios";
import Axios from "axios";
import { BrowserInfo } from "../browser";
import { CtepEctError } from "../ctep/ctep-ect-error";
import { CtepSaleResult } from "../ctep/ctep-sale-result";
import { ICtepService } from "../ctep/ctep-service";
import { CtepService } from "@/services/ctep-service";



const host = `${BrowserInfo.getElectronUrl()}/ctep`;

export class ElectronCtepClass implements ICtepService {

	public async init(){
		if (!this.canRun()) return;
		let settings = CtepService.getSettings();
		if (settings.mode == "off") return;
		this.startService();
	}

	public async reinit(){
		if (!this.canRun()) return;
		await this.deinit();
		await this.init();
	}

	public async deinit(){
		if (!BrowserInfo.hasElectronConfigured()) return;
		await this.stopService();
	}

	private async startService():Promise<void>{
		if (!this.canRun()) return;
		let settings = CtepService.getSettings();
		let body:any = {
			port: settings.port,
			comPort: settings.comPort,
			connectUrl: settings.connectUrl
		};
		console.log(body.connectUrl);
		await Axios.post(`${host}/start-service/${settings.mode}`, body);
		await this.setSelfCertificationMode(settings.selfCertificationModeEnabled);
	}

	private async stopService():Promise<void>{
		if (!BrowserInfo.hasElectronConfigured()) return;
		await Axios.post(`${host}/stop-service`);
	}

	public async isServiceRunning():Promise<boolean>{
		let result = await Axios.get(`${host}/is-service-runnig`);
		return result.data == "true";
	}

	private async setSelfCertificationMode(enabled:boolean){
		await Axios.post(`${host}/set-self-certification-mode`, {enabled});
	}

	private ectErrorHandler(err:any){
		let error = err as AxiosError;
		if (error.response){
			if (typeof(error.response.data) == "object") {
				throw new CtepEctError(error.response.data);
			}
		}
		throw err;
	}

	public async sendSaleTransaction(amount:number, reference:string):Promise<CtepSaleResult>{
		try{
			let result = await Axios.post(`${host}/send-sale-transaction`, {amount, reference}, {timeout: 120000});
			return new CtepSaleResult(result.data);
		}catch(err){
			this.ectErrorHandler(err);
			throw err;
		}
	}

	public async cancelSale(){
		try{
			await Axios.post(`${host}/cancel-sale`);
		}catch(err){
			this.ectErrorHandler(err);
		}
	}

	public async listSerialPorts():Promise<string[]>{
		let result = await Axios.get(`${host}/list-serial-ports`);
		return result.data;
	}

	private canRun():boolean {
		if (!BrowserInfo.hasElectronConfigured()) return false;
		if (!CtepService.hasModule()) return false;
		return true;
	}

	lastTransaction(): Promise<CtepSaleResult> {
		throw new Error("Method not implemented.");
	}
}

export const ElectronCtep = new ElectronCtepClass();